import React, { FC } from 'react';
import { StatusBar, SafeAreaView } from 'react-native';
import styled from '@emotion/native';
import { LinearGradient } from 'expo-linear-gradient';
import { runOnJS } from 'react-native-reanimated';
import { Directions, Gesture, GestureDetector, ScrollView } from 'react-native-gesture-handler';

import {
  StatusModal,
} from '@components/2-molecules';

import { ThemeProvider } from '@emotion/react';
import setTheme from '@lib/theme';
import { useNavigation } from '@react-navigation/core';

import Menu from '@assets/icons/sandwich';
import { STATE, APIData } from '@lib/constants';
import { Spacer } from '@components/1-atoms';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useKeyboard } from '@lib/hooks/base/useKeyboardHeight';


const GradiantContainer = styled(LinearGradient)`
  height: 100%;
  position: relative;
  background-color: ${({ theme }: any) => `${theme.white}`};
`;


const Content = styled.View`
  flex: 1;
  margin: 0 auto;
  width: ${({ noPadding }: any) => noPadding ? `100%` : `${theme.contentWidth}px`};

  ${(props) => props?.keyboardHeight && `
    padding-bottom: ${props?.keyboardHeight}px;
  `}
`;


type Props = {
  children: React.ReactNode;
  style?: object;
  gradiant?: any;
  hooks?: Array<APIData>;
  panToOpenDrawer?: boolean;
};

const theme = setTheme('light');

const AppTemplate: FC<Props> = ({ children, style, panToOpenDrawer, hooks, gradiant = theme.gradients.primary, ...props }) => {

  const insets = useSafeAreaInsets();
  // Address possible notch on some devices:
  const notchSpace = Math.round(insets.top / 12);
  const navigation = useNavigation() as any;

  const keyboardHeight = useKeyboard();

  const scrollViewRef = React.useRef(null);
  React.useEffect(() => {
    // @ts-ignore
    scrollViewRef.current?.scrollTo({ x: 0, y: keyboardHeight, animated: true });
  }, [keyboardHeight]);


  const flingGesture = Gesture.Fling().direction(Directions.RIGHT).onEnd((event) => {
    // The navigation function must be executed on the JS thread
    if (event.absoluteX /* translationX */ > 120) {
      // Use runOnJS to move the navigation call back to the JavaScript thread
      if (panToOpenDrawer) {
        runOnJS(navigation.toggleDrawer)();
      }

    }
  });

  return (
    <GestureDetector gesture={flingGesture}>
      <SafeAreaView style={{ flex: 1 }}>

        <GradiantContainer style={style} theme={theme} {...gradiant}>
          <StatusBar backgroundColor={"#000000"} barStyle={'light-content'} />
          <Spacer h={notchSpace} />

          <ScrollView
            ref={scrollViewRef}
            style={{ flex: 1 }}
            contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }}
          >
            <Content keyboardHeight={keyboardHeight} {...props}>
              {children}
            </Content>
          </ScrollView>

        </GradiantContainer>

        {
          hooks?.map((hook : APIData, index: number) => {
            return <StatusModal {...hook} key={index} />;
          })
        }

      </SafeAreaView>
    </GestureDetector >
  );
};

export default AppTemplate;